import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase"; // 🔁 Make sure path is correct

const BulkOrderUploader = () => {
  const [rawData, setRawData] = useState("");
  const [status, setStatus] = useState("");

  const handleUpload = async () => {
    const lines = rawData.trim().split("\n");
    const headers = lines[0].split("\t");
    
    const orders = lines.slice(1).map((line) => {
      const values = line.split("\t");
      const order = {};
      headers.forEach((header, i) => {
        let key = header.trim();
        let value = values[i]?.trim();

        // Auto convert data types
        if (value === "TRUE") value = true;
        if (value === "FALSE") value = false;

        order[key] = value;
      });
      return order;
    });

    try {
      const orderCollection = collection(db, "orders");
      for (const order of orders) {
        await addDoc(orderCollection, order);
      }
      setStatus("✅ All orders uploaded successfully.");
    } catch (err) {
      console.error("Upload failed:", err);
      setStatus("❌ Error uploading orders. See console.");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>📤 Bulk Order Uploader</h2>
      <textarea
        rows={15}
        cols={100}
        placeholder="Paste tab-separated data from Google Sheets here"
        value={rawData}
        onChange={(e) => setRawData(e.target.value)}
      ></textarea>
      <br /><br />
      <button onClick={handleUpload}>Upload Orders</button>
      <p>{status}</p>
    </div>
  );
};

export default BulkOrderUploader;
